var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 1.237L.866 7.84a.5.5 0 1 1-.732-.684L6.634.16a.498.498 0 0 1 .732 0l6.503 6.997a.5.5 0 0 1-.731.684L7 1.237z","fillRule":"evenodd"}));
}

ArrowUp.defaultProps = {"width":"14","height":"8"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
